import { createContext } from 'react'
import { UserContextType } from './type'

const defaultProvider: UserContextType = {
  currentUserData: null,
  refreshUserinfo: () => null,
  updateUserData: () => null,
  resetUserData: () => null,
  isLoading: true,
}

const UserContext = createContext<UserContextType>(defaultProvider)

UserContext.displayName = 'UserContext'

export default UserContext
